import { ReactComponent as AssetSvg } from '../assets/stationWagon.svg';
import React from 'react';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

const StationWagon = (props: {style?: CSSProperties; className?: string}) => {
    return (
        <AssetSvg className={props.className} />
    );
}

export { StationWagon };